import { styled, Box, Typography, Chip, Button } from '@mui/material';
import { lighten, darken } from '@mui/material/styles';

interface WhatsappTypeSelectorOptionStyleProps {
  selected: boolean;
}

export const WhatsappTypeSelectorOptionContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'selected',
})<WhatsappTypeSelectorOptionStyleProps>(({ theme, selected }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  border: `1px solid`,
  borderRadius: 12,
  borderColor: selected ? theme.palette.primary.main : theme.palette.grey[400],
  width: '100%',
  padding: theme.spacing(1.75, 2),
  justifyContent: 'space-between',
  gap: theme.spacing(0.5),
}));

export const WhatsappTypeSelectorOptionHeader = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const WhatsappTypeSelectorOptionHeaderTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<WhatsappTypeSelectorOptionStyleProps>(({ theme, selected }) => ({
  ...theme.typography.body1,
  fontWeight: theme.typography.fontWeightBold,
  color: selected ? theme.palette.primary.main : theme.palette.text.primary,
}));

export const WhatsappTypeSelectorOptionHeaderSubTitle = styled(Typography)(
  ({ theme }) => ({
    ...theme.typography.body2,
    marginTop: theme.spacing(0.25),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
  }),
);

export const WhatsappTypeSelectorOptionActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const WhatsappTypeSelectorOptionActionsStatusChip = styled(Chip)(
  ({ theme, color }) => ({
    fontWeight: theme.typography.fontWeightBold,

    ...(color &&
      color !== 'default' && {
        backgroundColor: lighten(theme.palette[color].light, 0.5),
        color: darken(theme.palette[color].light, 0.5),
        borderColor: darken(theme.palette[color].light, 0.5),
      }),
  }),
);

export const WhatsappTypeSelectorOptionActionsButton = styled(Button)({
  minWidth: 0,
});

export const WhatsappTypeSelectorOptionHelperText = styled(Typography)(
  ({ theme }) => ({
    ...theme.typography.caption,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.secondary,
  }),
);
